import { Component, Host, inject, OnInit, Optional } from "@angular/core";
import { MatSidenav } from "@angular/material/sidenav";
import { Route, Router } from "@angular/router";
import { UserService } from "../../../user/services/user.service";
import { PermissionHelper } from "../../../../shared/helpers/permission.helper";
import { administrationRoutes } from "../../../administration/administration.routes";

@Component({
  selector: "app-navigation",
  templateUrl: "./navigation.component.html",
  styleUrls: ["./navigation.component.scss"],
})
export class NavigationComponent {
  private readonly _routes: Route[] = [];
  _router = inject(Router);
  userService = inject(UserService);
  administrationRoutes = administrationRoutes;
  openSubmenus: { [key: string]: boolean } = {};

  constructor(@Host() @Optional() private _sidenav: MatSidenav) {
    this._routes = this._router.config;
  }

  public getRoutes(): Route[] {
    return this._routes;
  }

  public close(): void {
    if (this._sidenav) {
      this._sidenav.close();
    }
  }

  isMenuItemDisplayed(route: Route) {
    const user = this.userService.getUser().getValue();
    if (!user) {
      return false;
    }

    const hasTitle = route.data?.["title"];
    const canUserActivate = PermissionHelper.canUserActivate(user, route);
    return hasTitle && canUserActivate;
  }

  toggleSubmenu(path: string | undefined): void {
    if (!path) {
      return;
    }
    this.openSubmenus[path] = !this.openSubmenus[path];
  }

  isSubmenuOpen(path: string | undefined): boolean {
    if (!path) {
      return false;
    }
    return this.openSubmenus[path];
  }

  isRouteActive(route: Route): boolean {
    // Cas spécial pour la page d'accueil (chemin vide)
    if (!route.path || route.path === '') {
      return this._router.url === '/' || this._router.url === '';
    }

    // Pour les autres routes, vérifier si l'URL commence par le chemin de la route
    return this._router.url.startsWith('/' + route.path);
  }

  hasAccess(child: Route) {
    const user = this.userService.getUser().getValue();
    if (!user) {
      return false;
    }

    return PermissionHelper.canUserActivate(user, child);
  }
}
